<template>
	<div class="sticky-top" v-if="isShowMainNav">
		<!-- Notice -->
		<div
		v-for="(notice) in notices"
		:key="notice._id">
			<app-notice
				:level="notice.level"
				:title="notice.title"
				:description="notice.description"
				:isActive="notice.is_active"
				@dismiss="dismiss(notice.visibility)"
				v-if="user && notices.length > 0 && isShowNotice(notice.visibility)"
			/>
		</div>

		<div
		v-for="(notice) in noticePublics" :key="notice._id"
		>
			<app-notice
				:level="notice.level"
				:title="notice.title"
				:description="notice.description"
				:isActive="notice.is_active"
				@dismiss="dismiss(notice.visibility)"
				v-if="user && noticePublics.length > 0 && isShowNotice(notice.visibility)"
			/>
		</div>
		<!-- Navbar -->
		<nav
			class="navbar navbar-main navbar-light navbar-expand-lg"
			:class="{ 'custom-shadow': isCustomShadow }"
		>
			<div class="container">
				<router-link class="navbar-brand" to="/">
					<img
						:src="appLogo"
						width="150px"
						class="d-inline-block align-top"
						:alt="appName"
					/>
				</router-link>

				<a
					v-if="isShowCategory && allCategories.length > 0"
					class="d-lg-none text-bold dropdown-toggle text-decoration-none"
					data-toggle="dropdown"
					aria-haspopup="true"
					:aria-expanded="showCategoryDropdown"
					@click="showCategoryDropdown = !showCategoryDropdown"
				>
					<span class="category-toggle">
						Kategori
					</span>
				</a>

				<button
					class="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target="#main-nav-dropdown"
					aria-controls="navbarNavDropdown"
					aria-expanded="false"
					aria-label="Toggle navigation"
				>
					<span class="navbar-toggler-icon"></span>
				</button>
				<div
					class="main-nav-dropdown collapse navbar-collapse justify-content-end"
					id="main-nav-dropdown"
				>
					<ul class="navbar-nav d-none d-lg-block align-items-lg-center" v-if="isShowCategory && allCategories.length > 0">
						<li class="dropdown">
							<div class="nav-link">
								<button
									class="btn-outline o-lg outline-primary border-0"
									data-toggle="dropdown"
									aria-haspopup="true"
									:aria-expanded="showCategoryDropdown"
								>
									Kategori
								</button>
							</div>
							<category-dropdown-menu
								:show-category-dropdown="showCategoryDropdown"
								:all-categories="allCategories"
								@toggle="toggleDropdown">
							</category-dropdown-menu>
						</li>
					</ul>
					<div class="w-100" v-if="isShowSearchBar">
						<div class="desktop-search d-none d-lg-block w-80" ref="searchDesktop">
							<div class="nav-search-wrapper form-inline my-2 my-lg-0">
								<div class="nav-search-inner">
									<input v-model="searchQueryModel" class="mr-sm-2 search-input" type="text" placeholder="Cari produk" @focus="showOptions" ref="searchInput">
								</div>
								<div class="nav-search-button">
									<i class="bi-search my-2 my-sm-0"></i>
								</div>
							</div>
							<div class="option card shadow" v-if="isShowOptionSearch && searchQueryModel">
								<ul class="list-group">
									<li class="list-group-item" role="button" @click="applySearchProduct"><i class="fas fa-cube"></i> Cari <span class="text-primary">'{{ searchQueryModel }}'</span> Berdasarkan Product</li>
									<li class="list-group-item" role="button" @click="applySearchSupplier"><i class="fas fa-truck"></i> Cari <span class="text-primary">'{{ searchQueryModel }}'</span> Berdasarkan Supplier Code</li>
								</ul>
							</div>

						</div>

						<div class="mobile-search d-lg-none">
							<div class="my-2">Cari Produk</div>
							<div class="nav-search-wrapper form-inline my-2 my-lg-0">
								<div class="nav-search-inner">
									<input v-model="searchQueryModel" class="mr-sm-2 search-input" type="text" placeholder="Cari produk" @focus="showOptions" ref="searchInput">
								</div>
								<div class="nav-search-button">
									<i class="bi-search my-2 my-sm-0"></i>
								</div>
							</div>
							<div class="option card shadow" v-if="isShowOptionSearch && searchQueryModel">
								<ul class="list-group">
									<li class="list-group-item" role="button" @click="applySearchProduct"><i class="fas fa-cube"></i> Cari <span class="text-primary">'{{ searchQueryModel }}'</span> Berdasarkan Product</li>
									<li class="list-group-item" role="button" @click="applySearchSupplier"><i class="fas fa-truck"></i> Cari <span class="text-primary">'{{ searchQueryModel }}'</span> Berdasarkan Supplier Code</li>
								</ul>
							</div>
						</div>
					</div>

					<div v-if="isShowPrivateOrderSearchBar && searchBarPos === 'navbar'" class="private-order-search-wrapper">
						<div>
							<private-order-search-bar placeholder="Cari Produk" />
						</div>
					</div>

					<!-- Right Side Of Navbar -->
					<ul class="navbar-nav align-items-start align-items-lg-center">
						<li v-if="!user && !isFetchingUser">
							<router-link
								class="nav-link"
								to="/login"
							>
								<button class="btn-outline o-lg outline-primary btn-block"><span class="auth-label">Masuk</span></button>
							</router-link>
						</li>
						<li v-if="!user && !isFetchingUser">
							<router-link
								class="nav-link"
								to="/register"
							>
								<button class="btn-outline o-lg outline-primary btn-block active"><span class="auth-label">Daftar</span></button>
							</router-link>
						</li>
						<!-- <li v-if="!user && !isFetchingUser">
							<a 	class="nav-link">
								<div class="dropdown">
									<button
										data-mdb-button-init data-mdb-ripple-init data-mdb-dropdown-init class="btn-sm btn-outline o-lg outline-primary btn-block active"
										type="button"
									>
										Daftar
									</button>
									<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
										<li><a class="dropdown-item" href="/register">Daftar sebagai Seller</a></li>
										<li><a class="dropdown-item" href="/register/supplier">Daftar sebagai Supplier</a></li>
									</ul>
								</div>
							</a>
						</li> -->
						<template v-if="user">
							<li>
								<router-link
									class="nav-link"
									to="/"
								>
									<button
										class="btn-outline o-lg outline-primary"
										:class="{ active: isMenuActive('/') }"
										v-tooltip="'Home'"
									>
										<i class="bi-house-door-fill"></i>
									</button>
									<span class="label ml-2 d-lg-none">Home</span>
								</router-link>
							</li>
							<li v-if="isPrivateOrderVisible">
								<router-link
									class="nav-link"
									to="/wholesale-order"
								>
									<button
										class="btn-outline o-lg outline-primary"
										:class="{ active: isMenuActive('/wholesale-order') }"
										v-tooltip="'Wholesale Order'"
									>
										<i class="bi-house-lock-fill"></i>
									</button>
									<span class="label ml-2 d-lg-none">Wholesale Order</span>
								</router-link>
							</li>
							<li v-if="isOwner || isUserCan('product_view')">
								<router-link
									class="nav-link"
									to="/products"
								>
									<button
										class="btn-outline o-lg outline-primary"
										:class="{ active: isMenuActive('/products') }"
										v-tooltip="'Products'"
									>
										<i class="bi-box2-heart-fill"></i>
									</button>
									<span class="label ml-2 d-lg-none">Products</span>
								</router-link>
							</li>
							<li v-if="isDropshipper">
								<router-link
									class="nav-link"
									to="/wishlist"
								>
									<button
										class="btn-outline o-lg outline-primary"
										:class="{ active: isMenuActive('/wishlist') }"
										v-tooltip="'Wishlist'"
									>
										<i class="bi-heart-fill"></i>
									</button>
									<span class="label ml-2 d-lg-none">Products</span>
								</router-link>
							</li>
							<li v-if="isUserCanAccess">
								<router-link
									class="nav-link"
									to="/wholesale-order/list"
								>
									<button
										class="btn-outline o-lg outline-primary"
										:class="{ active: isMenuActive('/wholesale-order/list') }"
										v-tooltip="isDropshipper ? 'Orders' : 'Wholesale Orders'"
										@click="$router.push('/wholesale-order/list')"
									>
										<i class="bi bi-cart-check-fill"></i>
									</button>
									<span class="label ml-2 d-lg-none">{{ isDropshipper ? 'Orders' : 'Monitoring Wholesale Orders' }}</span>
								</router-link>
							</li>
							<li v-if="isSupplier || isUserCan('order_view')">
								<router-link
									v-tooltip="'Orders'"
									class="nav-link"
									to="/orders"
								>
									<button
										class="btn-outline o-lg outline-primary"
										:class="{ active: isMenuActive('/orders') }"
										v-tooltip="'Orders'"
										@click="$router.push('/orders')"
									>
										<i class="bi-ui-checks"></i>
									</button>
									<span class="label ml-2 d-lg-none">Orders</span>
								</router-link>
							</li>
							<!-- Others -->
							<li class="dropdown" v-if="isShowOther">
								<div class="nav-link">
									<button
										class="btn-outline o-lg outline-primary"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<i class="bi-three-dots"></i>
									</button>
									<span class="label ml-2 d-lg-none">Others</span>
								</div>
								<div class="dropdown-menu">
									<!-- Inventory -->
									<router-link class="dropdown-item" to="/inventory" v-if="isUserCan('inventory_view')">
										<!-- <i class="material-icons">inventory</i> -->
										<i class="fi fi-rr-box"></i>
										<span>{{ $t('menu.inventory') }}</span>
									</router-link>


									<!-- Payments -->
									<router-link
										class="dropdown-item hidden"
										to="/payments"
										v-if="isUserCan('payment_view')"
									>
										<!-- <i class="material-icons">account_balance</i> -->
										<i class="fi fi-rr-credit-card"></i>
										<span>{{ $t('menu.payments') }}</span>
									</router-link>

									<!-- Reports -->
									<!-- <router-link
										class="dropdown-item"
										to="/reports/team"
										v-if="isUserCan('report_team')">
										<i class="fi fi-rr-stats"></i>
										<span>{{ $t('Reports') }}</span>
									</router-link> -->

									<!-- Team Members -->
									<router-link class="dropdown-item" to="/members" v-if="isOwner || isUserCan('team_member_view')">
										<i class="fi fi-rr-users"></i>
										<span>{{ $t('menu.members') }}</span>
									</router-link>
								</div>
							</li>

							<!-- Others -->
							<li class="dropdown" v-if="isDropshipper">
								<div class="nav-link">
									<button
										class="btn-outline o-lg outline-primary"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<i class="bi-three-dots"></i>
									</button>
									<span class="label ml-2 d-lg-none">Others</span>
								</div>
								<div class="dropdown-menu">
									<!-- Inventory -->
									<router-link class="dropdown-item" to="/inventory">
										<!-- <i class="material-icons">inventory</i> -->
										<i class="fi fi-rr-box"></i>
										<span>{{ $t('menu.inventory') }}</span>
									</router-link>

									<!-- OStock Brand -->
									<!-- <router-link class="dropdown-item white-hover d-flex align-items-center" to="/brand/list">
										<i class="bi bi-tags icon-24 text-primary"></i>
										<span>{{ $t('Brand') }}</span>
									</router-link> -->

									<!-- OStock Direct -->
									<!-- <router-link class="dropdown-item white-hover d-flex align-items-center" to="/direct/list">
										<i class="bi bi-folder-symlink icon-24 text-primary"></i>
										<span>{{ $t('Direct') }}</span>
									</router-link> -->

									<!-- Request Product -->
									<router-link class="dropdown-item white-hover d-flex align-items-center" to="/request-product/list">
										<i class="bi bi-box2 icon-24 text-primary"></i>
										<span>{{ $t('Request Product') }}</span>
									</router-link>
								</div>
							</li>

							<!-- Notifications -->
							<li class="dropdown m-0">
								<notifications></notifications>
							</li>
							<!-- Logistics Notifications -->
							<!-- <li class="nav-item m-0">
								<logistic-notifications />
							</li> -->
							<!-- Profile -->
							<li class="dropdown">
								<!-- <a
									class="nav-link dropdown-toggle profile-toggle"
									href="#"
									data-toggle="dropdown"
									:title="user.name"
								>
									<div
										class="nav-profile-picture"
										:style="{ backgroundImage: `url('${user.picture}')` }"
										v-if="isUserHasPicture"
									></div>
									<i class="material-icons md-36" v-if="!isUserHasPicture"
										>account_circle</i
									>
									<span class="label ml-2">{{ user.name }}</span>
								</a> -->
								<div class="nav-link">
									<button
										class="btn-outline o-lg outline-primary"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<i class="bi-person-fill"></i>
									</button>
									<span class="label ml-2 d-lg-none">{{ user.name }}</span>
								</div>
								<div class="dropdown-menu dropdown-menu-right pt-0">
									<!-- Header -->
									<div class="dropdown-item bg-main">
										<div class="mb-2 pt-3 pb-3">
											<b>{{ user.name }}</b>
											<!-- <small class="text-uppercase ml-1">({{ user.role }})</small> -->
										</div>
										<!-- <div>
											<a :href="`mailto:${user.email}`" target="_blank">{{ user.email }}</a>
										</div> -->
										<!-- <div class="mt-1">Plan: <span class="text-capitalize">{{ user.package }}</span></div> -->
									</div>
									<!-- Admin -->
									<!-- <router-link
										class="dropdown-item"
										to="/admin"
										v-if="isAdminAreaVisible"
									>
										<i class="material-icons">insert_chart</i>
										<span>{{ $t('menu.admin') }}</span>
									</router-link> -->
									<!-- Wishlist -->
									<!-- <router-link
										class="dropdown-item"
										to="/wishlist"
										v-if="isDropshipper"
									>
										<i class="material-icons">favorite</i>
										<span>{{ $t('Wishlist') }}</span>
									</router-link> -->
									<!-- Profile -->
									<router-link class="dropdown-item" to="/profile">
										<i class="material-icons">account_circle</i>
										<span>{{ $t('menu.profile') }}</span>
									</router-link>
									<!-- Credits -->
									<router-link
										class="dropdown-item"
										to="/credits"
										v-if="(isOwner && isSupplier) || isUserCan('wallet_view')"
									>
										<i class="material-icons">account_balance_wallet</i>
										<span>{{ $t('Credits') }}</span>
									</router-link>
									<!-- Billings -->
									<router-link
										class="dropdown-item"
										to="/billings"
										v-if="isDropshipper || isUserCan('billings_view')">
										<i class="material-icons">payment</i>
										<span>{{ $t('Billings') }}</span>
									</router-link>
									<!-- Plans -->
									<!-- <router-link class="dropdown-item" to="/plans" v-if="isOwner">
										<i class="material-icons">local_offer</i>
										<span>{{ $t('menu.changePlan') }}</span>
									</router-link> -->
									<!-- Settings -->
									<router-link
										class="dropdown-item"
										to="/settings"
										v-if="isOwner"
									>
										<i class="material-icons">settings</i>
										<span>{{ $t('menu.settings') }}</span>
									</router-link>
									<!-- What's New -->
									<a
										href="#"
										class="dropdown-item hidden"
										@click="toggleAnnouncements(true)"
										v-if="user"
									>
										<i class="material-icons">rss_feed</i>
										<span>{{ $t("What's New") }}</span>
									</a>
									<!-- Logout -->
									<a class="dropdown-item" @click="logout">
										<i class="material-icons">power_settings_new</i>
										<span>{{ $t('menu.signout') }}</span>
									</a>
								</div>
							</li>
						</template>
					</ul>

				</div>
			</div>
		</nav>
		<!-- <category-dropdown
			:show-category-dropdown="showCategoryDropdown"
			:all-categories="allCategories"
			@toggle="toggleDropdown"
		></category-dropdown> -->
		<category-dropdown-menu
			v-if="isShowCategory && allCategories.length > 0"
			class="d-lg-none"
			:is-mobile-view="true"
			:show-category-dropdown="showCategoryDropdown"
			:all-categories="allCategories"
			@toggle="toggleDropdown">
		</category-dropdown-menu>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppNotice from '@/components/AppNotice.vue';
import Notifications from '@/components/Notifications.vue';
// import LogisticNotifications from '@/components/LogisticNotifications.vue';
// import CategoryDropdown from '@/components/CategoryDropdown.vue';
import CategoryDropdownMenu from '@/components/CategoryDropdownMenu.vue';
import PrivateOrderSearchBar from '@/components/private-orders/homepage/SearchBar.vue';
import homepageApi from '@/api/homepage';
import { isTester } from '@/lib/helper';

export default {
	name: 'SuperNavIntro',
	components: {
		AppNotice,
		Notifications,
		// CategoryDropdown,
		CategoryDropdownMenu,
		// LogisticNotifications,
		PrivateOrderSearchBar,
	},
	data() {
		return {
			shrink: false,
			// isShowMainNav: true,
			// searchQuery: '',
			// searchType: 'product',
			showCategoryDropdown: false,
			allCategories: [],
			isShowOptionSearch: false,
		};
	},
	methods: {
		...mapActions({
			logout: 'logout',
			toggleAnnouncements: 'toggleAnnouncements',
			dismissNotice: 'dismissNotice',
			setSearchQuery: 'homepage/setSearchQuery',
			setSearchType: 'homepage/setSearchType',
		}),
		isShowNotice(type) {
			let isDismissed = false;
			const notice = type === 'public' ? this.noticePublics[0] : this.notices[0];
			const route = this.$route.name;
			const isNotPageEditor = route !== 'PageEditor';
			if (notice && isNotPageEditor) {
				const uiSettings = this.settings.ui;
				let dismissDateString = '';
				if (notice.visibility === 'public') {
					dismissDateString = uiSettings.last_dismissed_notice || '2009-01-01 00:00:00';
				} else {
					dismissDateString = uiSettings.last_dismissed_notice_role || '2009-01-01 00:00:00';
				}

				// Parse dates using moment
				const lastDismissed = this.moment(dismissDateString);
				const createdAt = notice.created_at;
				const timezone = this.user ? this.user.timezone : 'Asia/Jakarta';
				const dateFormat = 'YYYY-MM-DD HH:mm:ss';
				const noticeDate = this.moment.utc(createdAt, dateFormat).tz(timezone);

				// Check if the notice is dismissed
				isDismissed = noticeDate.isSameOrAfter(lastDismissed);

				return isDismissed;
			}

			return isDismissed;
		},
		handleScroll() {
			const scrollPosition = window.scrollY;
			const treshold = 0;
			this.shrink = scrollPosition > treshold;
		},
		dismiss(type) {
			this.dismissNotice(type);
		},
		applySearch() {
			this.setSearchQuery(this.searchQuery);

			if (this.searchType === 'supplier') {
				this.$router.push({ path: `/supplier/${this.searchQueryModel}` });
			} else if (this.searchQuery !== '') {
				this.$router.push({ path: '/search', query: { st: this.searchType, q: this.searchQuery } });
			}

			this.isShowOptionSearch = false;
		},
		applySearchProduct() {
			this.setSearchType('product');
			this.applySearch();
		},
		applySearchSupplier() {
			this.setSearchType('supplier');
			this.applySearch();
		},
		fetchCategories() {
			const callback = (response) => {
				this.allCategories = response.data;
			};
			const errorCallback = (e) => {
				console.log(e);
			};
			homepageApi.getAllCategories(callback, errorCallback);
		},
		toggleDropdown(value) {
			this.showCategoryDropdown = value;
		},
		handleClickOutside(event) {
			const card = this.$refs.searchDesktop;

			if (card && !card.contains(event.target)) {
				this.isShowOptionSearch = false;
			}
		},
		showOptions() {
			this.isShowOptionSearch = true;
		},
	},
	computed: {
		...mapGetters({
			isFetchingUser: 'isFetchingUser',
			user: 'user',
			isOwner: 'isOwner',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			settings: 'settings',
			isMenuActive: 'isMenuActive',
			isAdmin: 'isAdmin',
			isSupport: 'isSupport',
			isUserCan: 'isUserCan',
			announcements: 'announcements',
			notices: 'notice',
			noticePublics: 'noticePublics',
			appName: 'appName',
			appLogo: 'appLogo',
			isStorefrontActive: 'isStorefrontActive',
			isNewPlan: 'isNewPlan',
			isHasFeature: 'isHasFeature',
			searchQuery: 'homepage/searchQuery',
			searchType: 'homepage/searchType',
			searchBarPos: 'privateOrder/searchBarPos',
		}),
		isUserCanAccess() {
			const feature = 'private_order';
			let isCanAccess = false;
			if (this.isOwner || this.isAdmin) {
				isCanAccess = this.isHasFeature(feature);
			} else {
				isCanAccess = this.isUserCan('wholesale_view_order');
			}

			return isCanAccess;
		},
		isUserHasPicture() {
			return this.user.picture !== '';
		},
		isPaidUser() {
			return this.user.package !== 'free';
		},
		// isOwner() {
		// 	return (
		// 		this.user
		// 		&& (this.user.role === 'owner' || this.user.role === 'dropshipper')
		// 	);
		// },
		isCanAddProduct() {
			return this.isUserCan('product_add');
		},
		updates() {
			return this.announcements.filter(item => item.type === 'update');
		},
		isAnnouncementsUnread() {
			let isUnread = false;
			const lastAnnouncement = this.updates[0];
			if (lastAnnouncement) {
				const lastReadString =					this.settings.ui.last_opened_announcements !== ''
					? this.settings.ui.last_opened_announcements
					: '2009-01-01 00:00:00';
				const lastRead = this.moment(lastReadString);
				const createdAt = lastAnnouncement.created_at;
				const timezone = this.user ? this.user.timezone : 'Asia/Jakarta';
				const lastAnnouncementDate = this.moment
					.utc(createdAt, 'YYYY-MM-DD HH:mm:ss')
					.tz(timezone);
				isUnread = lastAnnouncementDate.isSameOrAfter(lastRead);
			}
			return isUnread;
		},
		// isShowNotice() {
		// 	let isDismissed = false;
		// 	const notices = this.notices;
		// 	const route = this.$route.name;
		// 	const isNotPageEditor = route !== 'PageEditor';
		// 	notices.forEach((notice) => {
		// 		if (notice && isNotPageEditor) {
		// 			const uiSettings = this.settings.ui;
		// 			let dismissDateString = '';
		// 			if (notice.visibility === 'public') {
		// 				dismissDateString = uiSettings.last_dismissed_notice || '2009-01-01 00:00:00';
		// 			} else {
		// 				dismissDateString = uiSettings.last_dismissed_notice_role || '2009-01-01 00:00:00';
		// 			}

		// 			// Parse dates using moment
		// 			const lastDismissed = this.moment(dismissDateString);
		// 			const createdAt = notice.created_at;
		// 			const timezone = this.user ? this.user.timezone : 'Asia/Jakarta';
		// 			const dateFormat = 'YYYY-MM-DD HH:mm:ss';
		// 			const noticeDate = this.moment.utc(createdAt, dateFormat).tz(timezone);

		// 			// Check if the notice is dismissed
		// 			isDismissed = noticeDate.isSameOrAfter(lastDismissed);

		// 			return isDismissed;
		// 		}
		// 	});

		// 	return isDismissed;
		// },
		isBetaTester() {
			return this.isAdmin || isTester(this.user._id);
		},
		isShowMainNav() {
			const route = this.$route.name;
			return route !== 'PageEditor' && route !== 'CourseDetail' && route !== 'login' && route !== 'register';
		},
		isShowOther() {
			const isVisible = this.user
			&& (this.isUserCan('team_member_view') || this.isUserCan('inventory_view'));
			// || this.isUserCan('logistic_report')
			// || this.isUserCan('expense_view')
			// || this.isUserCan('rotator_view');
			return isVisible;
			// return false;
		},
		isAdminAreaVisible() {
			const visible =	this.isAdmin
				|| this.isSupport
				|| this.isHasFeature('admin_billings')
				|| this.isHasFeature('admin_logistics_search')
				|| this.isHasFeature('admin_logistics_monitoring');
			return visible;
		},
		isPrivateOrderVisible() {
			const visible = this.isHasFeature('private_order') && this.isDropshipper;
			return visible;
		},
		isShowSearchBar() {
			return (this.$route.name === 'home'
				|| this.$route.name === 'search'
				|| this.$route.name === 'supplier-products'
				|| this.$route.name === 'product-detail') && ((!this.user) || (this.user && this.isDropshipper));
		},
		isShowPrivateOrderSearchBar() {
			return this.$route.name === 'wholesale-order';
		},
		isShowCategory() {
			return this.isShowSearchBar;
		},
		searchQueryModel: {
			get() {
				return this.searchQuery;
			},
			set(value) {
				this.setSearchQuery(value);
			},
		},
		searchTypeModel: {
			get() {
				return this.searchType;
			},
			set(value) {
				this.setSearchType(value);
			},
		},
		isCustomShadow() {
			return this.$route.name === 'private-order-detail';
		},
	},
	watch: {
		$route() {
			const navId = '#main-nav-dropdown';
			if (typeof $ !== 'undefined') {
				$(navId).collapse('hide');
			} else if (typeof jQuery !== 'undefined') {
				jQuery(navId).collapse('hide');
			}
		},
		searchQueryModel() {
			this.isShowOptionSearch = true;
		},
	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
		if (this.$refs.searchInput) {
			this.$refs.searchInput.addEventListener('focus', this.showOptions);
		}
		this.search = this.$route.query.q || '';
		this.fetchCategories();
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('focus', this.showOptions);
	},
};
</script>
<style lang="scss" scoped>
	.custom-shadow {
		box-shadow: none !important;
		border-bottom: none !important;
	}

	.nav-search-wrapper {
		background: #fff;
		border: 2px solid #A0ACBD;
		border-radius: 30px;
		width: 100%;
		height: 48px;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;

		.nav-search-inner {
			flex-grow: 1;
			display: flex;

			.dropdown {
				border: 0;
				margin-left: 10px;
				margin-right: 10px;
				padding-right: 30px;
				font-weight: 500;
				font-size: 16px;
				line-height: 150%;
				color: rgba(27, 28, 30, 0.38);
				background-image: url("/images/icon-select-arrow-down.png");
				background-position: right 10px center;
				background-repeat: no-repeat;
				background-size: 10px;
				-webkit-appearance:none;
				appearance:none;

				&:focus {
					outline: none !important;
				}
			}

			.search-input {
				border: 0;
				flex-grow: 1;
				margin-right: 10px;
				// border-left: 2px solid rgba(27, 28, 30, 0.38);
				padding-left: 10px;
				font-weight: 500;

				&::placeholder {
					color: rgba(27, 28, 30, 0.38);
					opacity: 1; /* Firefox */
					font-weight: 500;
				}

				&:-ms-input-placeholder { /* Internet Explorer 10-11 */
					color: rgba(27, 28, 30, 0.38);
					font-size: 16px;
				}

				&::-ms-input-placeholder { /* Microsoft Edge */
					color: rgba(27, 28, 30, 0.38);
					line-height: 150%;
				}

				&:focus {
					outline: none !important;
				}
			}
		}

		.nav-search-button {
			font-size: 20px;
			margin-right: 10px;
		}
	}

	.navbar-nav {
		margin-left: 8px;
		@media screen and (max-width: 991px) {
			margin-left: 0px;
		}
		// align-items: center;
	}

	.auth-label {
		padding-left: 30px;
		padding-right: 30px;
	}

	.desktop-search.w-80 {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
	}

	.icon-24 {
		font-size: 24px;
		margin-right: 12px;
	}

	.white-hover:hover {
		color: white !important;
		.icon-24 {
			color: white !important;
		}
	}

	.category-toggle {
		padding-right: 30px;
	}

	.option {
		position: absolute;
		width: 40%;
		margin-left: auto;
		margin-right: auto;
	}

	@media only screen and (max-width: 480px) {
		.option {
			width: 90%;
		}
	}

	@media only screen and (min-width: 481px) and (max-width: 720px) {
		.option {
			width: 75%;
		}
	}

	@media only screen and (min-width: 721px) and (max-width: 820px) {
		.option {
			width: 90%;
		}
	}

	@media only screen and (min-width: 821px) and (max-width: 1024px) {
		.option {
			width: 40%;
		}
	}

	/* Style hover */
	.list-group-item:hover {
		background-color: #f4f4f4;
	}
	.list-group-item {
		position: relative;
		padding-left: 50px;
	}

	.list-group-item i {
		margin-left: 20px;
		margin-right: 20px;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.navbar-nav {
		display: flex;
		justify-content: space-around; /* Menyamakan lebar tombol */
		align-items: center; /* Menyamakan tinggi tombol */
	}

	.btn-block {
		height: 50px;
		width: 150px;
	}

	.dropdown-toggle {
		line-height: 7px;
	}

	.navbar-main .dropdown-menu {
		min-width: 200px
	}

	.nav-link {
		text-align: -webkit-center;
	}

	.private-order-search-wrapper {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		& > div {
			width: 80%;
		}
	}
</style>
